/* Deal & Dink landing page behavior */
(function () {
  function animateScroll(el, delta) {
    var start = el.scrollLeft;
    var target = Math.max(0, Math.min(start + delta, el.scrollWidth - el.clientWidth));
    var dur = 360;
    var t0 = Date.now();
    function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    if (el._dndlpAnim) clearInterval(el._dndlpAnim);
    el._dndlpAnim = setInterval(function () {
      var p = Math.min(1, (Date.now() - t0) / dur);
      el.scrollLeft = start + (target - start) * ease(p);
      if (p >= 1) { clearInterval(el._dndlpAnim); el._dndlpAnim = null; }
    }, 16);
  }

  function init() {
    var buy = document.getElementById('dndlp-buy');

    // Card rail arrows (timer-based animation — rAF/native smooth scroll can be throttled)
    var rail = document.getElementById('dndlp-cards-rail');
    var railPrev = document.getElementById('dndlp-rail-prev');
    var railNext = document.getElementById('dndlp-rail-next');
    if (rail && railPrev && railNext) {
      rail.style.scrollBehavior = 'auto';
      railPrev.addEventListener('click', function () { animateScroll(rail, -618); });
      railNext.addEventListener('click', function () { animateScroll(rail, 618); });
    }

    if (!buy) return;

    var rows = Array.prototype.slice.call(document.querySelectorAll('.dndlp-tier'));
    var cta = document.getElementById('dndlp-cta');
    var stickyBar = document.getElementById('dndlp-sticky');
    var stickyCta = document.getElementById('dndlp-sticky-cta');
    var stickyLabel = document.getElementById('dndlp-sticky-label');
    var current = null;

    function select(row) {
      current = row;
      rows.forEach(function (r) {
        var on = r === row;
        r.classList.toggle('is-selected', on);
        r.setAttribute('aria-checked', on ? 'true' : 'false');
        r.tabIndex = on ? 0 : -1;
      });
      if (cta) cta.textContent = row.dataset.cta;
      if (stickyCta) stickyCta.textContent = row.dataset.cta;
      if (stickyLabel) stickyLabel.textContent = row.dataset.sticky;
    }

    rows.forEach(function (r) {
      r.addEventListener('click', function () { select(r); });
      r.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(r); }
      });
    });
    var def = null;
    rows.forEach(function (r) { if (r.dataset.default === 'true') def = r; });
    if (!def && rows.length) def = rows[0];
    if (def) select(def);

    function openDrawer() {
      try {
        if (window.Upcart && typeof window.Upcart.openCart === 'function') { window.Upcart.openCart(); return true; }
        if (window.upcart && typeof window.upcart.openCart === 'function') { window.upcart.openCart(); return true; }
      } catch (e) {}
      var sels = ['[data-cart-toggle]', '.upcart-open-cart', '.upcart-cart-button', '.upcart-launcher', '#cart-icon-bubble', '.header__icon--cart'];
      for (var i = 0; i < sels.length; i++) {
        var el = document.querySelector(sels[i]);
        if (el) { el.click(); return true; }
      }
      return false;
    }

    var adding = false;
    function addToCart() {
      if (!current || adding) return;
      var id = parseInt(current.dataset.variant, 10);
      var qty = parseInt(current.dataset.qty || '1', 10);
      if (!id) { window.location.hash = 'dndlp-buy'; return; }
      adding = true;
      [cta, stickyCta].forEach(function (b) { if (b) b.classList.add('is-loading'); });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
        return r.json();
      }).then(function () {
        document.dispatchEvent(new CustomEvent('dndlp:added'));
        setTimeout(function () { if (!openDrawer()) window.location.href = '/cart'; }, 250);
      }).catch(function (e) {
        alert(e.message || 'Something went wrong adding this to your cart.');
      });
      setTimeout(function () {
        adding = false;
        [cta, stickyCta].forEach(function (b) { if (b) b.classList.remove('is-loading'); });
      }, 1500);
    }

    if (cta) cta.addEventListener('click', addToCart);
    if (stickyCta) stickyCta.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });

    // Gallery thumbs
    var mainImg = document.getElementById('dndlp-main-img');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.dndlp-thumb'));
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.removeAttribute('srcset');
        mainImg.src = t.dataset.full;
        thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
      });
    });

    // Bundle band CTA -> select bundle tier + scroll to buy box
    var bundleCta = document.getElementById('dndlp-bundle-cta');
    if (bundleCta) {
      bundleCta.addEventListener('click', function (e) {
        e.preventDefault();
        var bundleRow = document.querySelector('.dndlp-tier[data-tier="bundle"]');
        if (bundleRow) select(bundleRow);
        buy.scrollIntoView({ block: 'start' });
      });
    }

    // Scroll for internal anchors within landing sections
    Array.prototype.slice.call(document.querySelectorAll('a[href="#dndlp-buy"]')).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        buy.scrollIntoView({ block: 'start' });
      });
    });

    // Sticky bar: hide while the buy box CTA is on screen
    if (stickyBar) {
      document.body.classList.add('dndlp-has-sticky');
      if ('IntersectionObserver' in window && cta) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            stickyBar.classList.toggle('is-hidden', en.isIntersecting);
          });
        }, { threshold: 0 });
        io.observe(cta);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
